import { render } from "./UsersRolesTab.vue?vue&type=template&id=a0f63bf6&scoped=true&ts=true"
import script from "./UsersRolesTab.vue?vue&type=script&lang=ts"
export * from "./UsersRolesTab.vue?vue&type=script&lang=ts"

import "./UsersRolesTab.vue?vue&type=style&index=0&id=a0f63bf6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f63bf6"]])

export default __exports__